import axios from "axios";
import { getBaseUrl } from "../environment-url";
import { refreshAuthToken } from "../../hooks/hook";

const BONUS_API = axios.create({
  baseURL: getBaseUrl(process.env.REACT_APP_NODE_ENV, "BONUS_API"),
  responseType: "json",
  withCredentials: false,
  timeout: 10000, // 10 seconds
});

BONUS_API.interceptors.request.use((config) => {

  // Fetch the token from sessionStorage or localStorage
  let token = sessionStorage.getItem("token") || localStorage.getItem("token") || "";

  if (!token) {
    console.warn("No token found in sessionStorage or localStorage");
  }

  // Set the Authorization header
  config.headers["Authorization"] = `Bearer ${token}`;

  return config;
}, (error) => {
  console.error("Request Interceptor Error:", error);
  return Promise.reject(error);
});

//Add a response interceptor
BONUS_API.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.log("***********Unauthorized Error**********");
      await refreshAuthToken();
    }
    return Promise.reject(error);
  }
);


export default BONUS_API;